import PublisherLandings from '../../../../actions/PublisherLandings';
import query from '../../../../helpers/query';
import { removeParams } from '../helpers';
import CustomNotify from "../../../Notify";

let lastLandingsSignature = null;
let landingsRequestInFlight = false;

export const actions = {
    getLandings(state, actionType) {
        const params = {
            ...query.parseToSend(state),
            ...removeParams(),
            q: state.nameLink
        };

        const signature = JSON.stringify(params || {});
        if (landingsRequestInFlight && signature === lastLandingsSignature) {
            return;
        }

        lastLandingsSignature = signature;
        landingsRequestInFlight = true;

        const request = PublisherLandings.getLandings(params);
        if (request && typeof request.finally === 'function') {
            request.finally(() => {
                landingsRequestInFlight = false;
            });
        } else {
            landingsRequestInFlight = false;
        }
    },

    getOfferLinks(state) {
        const params = {
            ...query.parseToSend(state),
            ...removeParams()
        };

       return PublisherLandings.getOfferLinks(params);
    },

    saveLanding(state, t, onSuccess, onError) {
        const notyNames = t.notyMessages;

        let landingParams = {
            publisher_id: state.publisherId,
            offer_id: state.offer.id,
            link_id: state.currentLink.id,
            landing_id: state.landing.id,
            is_external: state.landing.is_external ? '1' : '0',
            external_url: state.landing.external_url || null,
            params: JSON.stringify(state.metaParams) !== '{}'
                ? JSON.stringify(state.metaParams)
                : JSON.stringify(state.landing.params),
        };

        PublisherLandings.saveLanding(landingParams).then(data => {
            CustomNotify(notyNames.update);
            onSuccess && onSuccess();
        }).catch(err => {
            onError && onError(err.error.invalid_parameters);
        });
    }
};
